import { http } from '@admin-base/core'

// 字典类型列表
const dictTypeList = data => {
    return http.post('api/ums/system/dict/type/list', data)
}
//  添加字典类型
const addDictType = data => {
    return http.post('api/ums/system/dict/type/add', data)
}
// 编辑字典类型
const editDictType = data => {
    return http.post('api/ums/system/dict/type/edit', data)
}
// 删除字典类型
const deleteDictType = data => {
    return http.post('api/ums/system/dict/type/deleteByIds/' + data, {})
}

// 字典数据列表
const dictDataList = data => {
    return http.post('api/ums/system/dict/data/list', data)
}

// 添加字典数据
const addDictData = data => {
    return http.post('api/ums/system/dict/data/add', data)
}
// 编辑字典数据
const editDictData = data => {
    return http.post('api/ums/system/dict/data/edit', data)
}
// 删除字典数据
const deleteDictData = data => {
    return http.post('api/ums/system/dict/data/deleteByIds/' + data, {})
}
export {
    dictTypeList,
    addDictType,
    editDictType,
    deleteDictType,
    dictDataList,
    addDictData,
    editDictData,
    deleteDictData,
}
